<template>
    <div id="app">
    <!-- <top-banner></top-banner> -->
      <router-view />
    <!-- <btm-banner></btm-banner> -->
    <el-backtop :bottom="0" :right="0"></el-backtop>
    </div>
</template>

<script>

  import topBanner from '@/components/topBanner.vue'
  import btmBanner from '@/components/btmBanner.vue'
  export default {
    name: 'App',
    components: {
      topBanner,
      btmBanner
    },

  }
</script>
<style>
  @import '/common/css/style.css';
  /* @import 'assets/font/font.css'; */

  #app {
    /* font-family: 'Microsoft YaHei',Arial, Helvetica, sans-serif; */
    /* -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center; */
    font-family: PingFang;
    color: #2c3e50;
    /* width: 100vw;
    height: 100vh;
    background: #fff;
    position: absolute;
    top: 0;
    left: 0;
    display: flex;
    align-content: center;
    justify-content: center;
    align-items: center; */
  }
  .el-backtop{
    width: 171px !important;
    height: 171px !important;
    background-color: transparent !important;
    background: url('../src/common/images/goTop.png');
    background-size: contain !important;
    border: 0px !important;
    box-shadow: none !important;
  }
  .el-backtop:hover{
    background-color: transparent !important;
    opacity: 0.8 !important;
  }
  .el-icon-caret-top:before{
    content: none !important;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue